/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import React from 'react';
import { useSelector } from 'react-redux';
import { loadReportingFrameworks } from '../../actions/reportingFrameworks';
import { Loader } from '@g17eco/atoms/loader';
import { ROUTES } from '../../constants/routes';
import { RootState, useAppDispatch } from '../../reducers';
import SDGAP from './SDGAP';

export const Taxonomy = () => {
  const dispatch = useAppDispatch();
  const frameworks = useSelector((state: RootState) => state.reportingFrameworks);

  React.useEffect(() => {
    dispatch(loadReportingFrameworks());
  }, [dispatch]);

  if (!frameworks.loaded || frameworks.reportType !== 'taxonomy') {
    return <Loader />;
  }

  return <SDGAP route={ROUTES.SDGAP} />;
};
